import dayjs from "dayjs";

export const formatEvents = (events: any) => {
  return events.map((event: any) => ({
    eventDate: event.eventDate,
    eventFormattedDate: dayjs(event.eventDate).format("DD/MM/YYYY"),
    eventType: event.eventType,
    eventId: event._id,
  }));
};
